import { __decorate, __param, __awaiter } from 'tslib';
import { CommonModule } from '@angular/common';
import { ɵɵdefineInjectable, Injectable, Optional, ɵɵinject, Component, Pipe, EventEmitter, Input, Output, NgModule, NgZone } from '@angular/core';
import { ModalController, Platform, ToastController, IonicModule } from '@ionic/angular';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ReplaySubject, BehaviorSubject, from, throwError, combineLatest, of } from 'rxjs';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { SplashScreen as SplashScreen$1 } from '@ionic-native/splash-screen/ngx/index';
import { shareReplay, catchError, concatMap, first, tap, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import createAuth0Client from '@auth0/auth0-spa-js';
import { Plugins } from '@capacitor/core';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import * as OpenTokWeb from '@opentok/client';
import { AndroidPermissions as AndroidPermissions$1 } from '@ionic-native/android-permissions/ngx/index';
import { HttpHeaders, HttpClient } from '@angular/common/http';

class VertueServiceConfig {
}

let UrlManagementService = class UrlManagementService {
    constructor() {
    }
    getLastPathName(url) {
        if (!url) {
            url = window.location.href;
        }
        // Remove the query parameters
        const queryParameterStart = url.indexOf('?');
        if (queryParameterStart > 0) {
            url = url.substr(0, queryParameterStart);
        }
        url = url.trim();
        // Check for trailing slash
        if (url[url.length - 1] === '/') {
            url = url.substr(0, url.length - 1);
        }
        let lastSlashIndex = url.lastIndexOf('/');
        if (lastSlashIndex >= 0) {
            lastSlashIndex++;
            url = url.substr(lastSlashIndex, url.length - lastSlashIndex);
        }
        return url;
    }
    getQueryVariable(variable) {
        const query = window.location.search.substring(1);
        const vars = query.split('&');
        for (let i = 0; i < vars.length; i++) {
            const pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) == variable) {
                return decodeURIComponent(pair[1]);
            }
        }
    }
    /**
     * Get the current Url's full query string excluding the htems specified in excludeItemMap
     * @param excludeItemMap
     */
    getQueryString(excludeItemMap) {
        let newQueryString = '';
        const query = window.location.search.substring(1);
        const vars = query.split('&');
        for (let i = 0; i < vars.length; i++) {
            const pair = vars[i].split('=');
            if (!excludeItemMap[decodeURIComponent(pair[0])]) {
                if (newQueryString.length === 0) {
                    newQueryString = '?';
                }
                else {
                    newQueryString += '&';
                }
                newQueryString += pair[0] + '=' + pair[1];
            }
        }
        return newQueryString;
    }
};
UrlManagementService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UrlManagementService_Factory() { return new UrlManagementService(); }, token: UrlManagementService, providedIn: "root" });
UrlManagementService = __decorate([
    Injectable({
        providedIn: 'root'
    })
], UrlManagementService);

let DebugService = class DebugService {
    constructor(urlManagementService, vertueServiceConfig) {
        this.urlManagementService = urlManagementService;
        this.vertueServiceConfig = vertueServiceConfig;
    }
    get isDebug() {
        if (this.urlManagementService.getQueryVariable('debug') === 'true') {
            return true;
        }
        else if (window.location.host && window.location.host.indexOf('localhost') >= 0) {
            if (this.urlManagementService.getQueryVariable('debug') === 'false') {
                return false;
            }
            else {
                return true;
            }
        }
    }
};
DebugService.ctorParameters = () => [
    { type: UrlManagementService },
    { type: VertueServiceConfig, decorators: [{ type: Optional }] }
];
DebugService.ngInjectableDef = ɵɵdefineInjectable({ factory: function DebugService_Factory() { return new DebugService(ɵɵinject(UrlManagementService), ɵɵinject(VertueServiceConfig, 8)); }, token: DebugService, providedIn: "root" });
DebugService = __decorate([
    Injectable({
        providedIn: 'root'
    }),
    __param(1, Optional())
], DebugService);

let ErrorHandlerDialogComponent = class ErrorHandlerDialogComponent {
    // constructor(private navParams: NavParams,
    //             private debugService: DebugService,
    //             private modalController: ModalController) {
    // }
    constructor(debugService, modalController) {
        this.debugService = debugService;
        this.modalController = modalController;
        this.currentErrorIndex = -1;
    }
    ngOnInit() {
        if (this.errorList && this.errorList.length > 0) {
            this.currentErrorIndex = this.errorList.length - 1;
        }
        //
        this.showDetails = this.debugService.isDebug;
    }
    onDismissModal() {
        this.modalController.dismiss();
    }
};
ErrorHandlerDialogComponent.ctorParameters = () => [
    { type: DebugService },
    { type: ModalController }
];
ErrorHandlerDialogComponent = __decorate([
    Component({
        // template: `
        //   <p>
        //     vertue-common works!
        //   </p>
        // `,
        template: "<ion-header translucent>\n    <ion-toolbar>\n        <ion-title>Service Error</ion-title>\n    </ion-toolbar>\n</ion-header>\n<ion-content>\n    <div class=\"padding-right-medium padding-left-medium\">\n        <p>\n            Ooops! We encountered an unexpected error while processing a request. Please try again later. If the problem\n            persists, please contact your system administrator.\n        </p>\n\n        <ng-container *ngIf=\"errorList[currentErrorIndex]\">\n            <div>\n                ({{errorList[currentErrorIndex]?.serviceResponse?.status}}) {{errorList[currentErrorIndex].url}}\n            </div>\n            <div>\n                {{errorList[currentErrorIndex]?.serviceResponse?.error?.message}}\n            </div>\n        </ng-container>\n\n        <p>\n            <strong>Event id: </strong>\n        </p>\n\n        <a class=\"pull-right link\" (click)=\"showDetails = !showDetails\">{{showDetails ? \"Hide\" : \"Show\"}} Error Details</a>\n        <div style=\"clear:both\"></div>\n        <div [hidden]=\"!showDetails\">\n            <pre *ngIf=\"currentErrorIndex >= 0\"><code>{{errorList[currentErrorIndex] | json}}</code></pre>\n        </div>\n    </div>\n\n\n</ion-content>\n<ion-footer>\n    <ion-toolbar>\n        <ion-buttons slot=\"end\" class=\"padding-small\">\n            <ion-button class=\"primary-outline medium\" (click)=\"onDismissModal()\">Contact Support</ion-button>\n            <ion-button class=\"primary medium\" (click)=\"onDismissModal()\">\n                Cancel\n            </ion-button>\n\n\n        </ion-buttons>\n    </ion-toolbar>\n\n</ion-footer>\n",
        styles: ["@-webkit-keyframes spin{0%{transform:rotateZ(0)}100%{transform:rotateZ(360deg)}}@keyframes spin{0%{transform:rotateZ(0)}100%{transform:rotateZ(360deg)}}ion-icon{width:80px;height:80px}.step-syncActive ion-icon{-webkit-animation:1.5s ease-in-out infinite spin;animation:1.5s ease-in-out infinite spin}.header{border-bottom:solid 1px var(--ion-color-grey);padding-bottom:1rem}"]
    })
], ErrorHandlerDialogComponent);

let PhoneNumberPipe = class PhoneNumberPipe {
    transform(tel, ...args) {
        if (!tel) {
            return '';
        }
        var value = tel.toString().trim().replace(/^\+/, '');
        if (value.match(/[^0-9]/)) {
            return tel;
        }
        var country, city, number;
        switch (value.length) {
            case 10: // +1PPP####### -> C (PPP) ###-####
                country = 1;
                city = value.slice(0, 3);
                number = value.slice(3);
                break;
            case 11: // +CPPP####### -> CCC (PP) ###-####
                country = value[0];
                city = value.slice(1, 4);
                number = value.slice(4);
                break;
            case 12: // +CCCPP####### -> CCC (PP) ###-####
                country = value.slice(0, 3);
                city = value.slice(3, 5);
                number = value.slice(5);
                break;
            default:
                return tel;
        }
        if (country == 1) {
            country = "";
        }
        number = number.slice(0, 3) + '-' + number.slice(3);
        return (country + " (" + city + ") " + number).trim();
    }
};
PhoneNumberPipe = __decorate([
    Pipe({
        name: 'phoneNumber'
    })
], PhoneNumberPipe);

var PhoneOrientation;
(function (PhoneOrientation) {
    PhoneOrientation["landscape"] = "landscape";
    PhoneOrientation["portrait"] = "portrait";
    PhoneOrientation["unknown"] = "unknown";
})(PhoneOrientation || (PhoneOrientation = {}));

var StudentViewType;
(function (StudentViewType) {
    StudentViewType["none"] = "none";
    StudentViewType["videoStream"] = "videoStream";
    StudentViewType["documentStream"] = "documentStream";
    StudentViewType["callStream"] = "callStream";
    StudentViewType["screenshareStream"] = "screenshareStream";
})(StudentViewType || (StudentViewType = {}));

var StudentDocumentLoadingStatus;
(function (StudentDocumentLoadingStatus) {
    StudentDocumentLoadingStatus["loading"] = "loading";
    StudentDocumentLoadingStatus["loaded"] = "loaded";
    StudentDocumentLoadingStatus["page change"] = "page change";
})(StudentDocumentLoadingStatus || (StudentDocumentLoadingStatus = {}));
;
var StudentDocumentName;
(function (StudentDocumentName) {
    StudentDocumentName["ActivationTraining"] = "activation training";
    StudentDocumentName["PublicAssessment"] = "public assessment";
    StudentDocumentName["PrivateAssessment"] = "private assessment";
    StudentDocumentName["PublicFoodAssessment"] = "public food assessment";
    StudentDocumentName["PrivateFoodAssessment"] = "private food assessment";
})(StudentDocumentName || (StudentDocumentName = {}));
;

var VideoLoadingState;
(function (VideoLoadingState) {
    VideoLoadingState["readyToPlay"] = "readyToPlay";
    VideoLoadingState["failed"] = "failed";
    VideoLoadingState["unknown"] = "unknown";
})(VideoLoadingState || (VideoLoadingState = {}));

var VideoPlaybackState;
(function (VideoPlaybackState) {
    VideoPlaybackState["waitingToPlay"] = "waitingToPlay";
    VideoPlaybackState["paused"] = "paused";
    VideoPlaybackState["playing"] = "playing";
    VideoPlaybackState["unknown"] = "unknown";
})(VideoPlaybackState || (VideoPlaybackState = {}));

let BrowserDetectService = class BrowserDetectService {
    constructor(platform, toastController) {
        this.platform = platform;
        this.toastController = toastController;
        this.isSafariInternal = navigator.userAgent.toLowerCase().indexOf('safari/') > -1;
    }
    get isNativeAndroid() {
        return this.isNative && this.platform.is('android');
    }
    get isNative() {
        return this.platform.is('hybrid');
    }
    get isSafariDesktop() {
        return this.platform.is('desktop') && this.getBrowserName() === 'safari';
    }
    getBrowserName() {
        const agent = window.navigator.userAgent.toLowerCase();
        switch (true) {
            case agent.indexOf('edge') > -1:
                return 'edge';
            case agent.indexOf('opr') > -1 && !!window.opr:
                return 'opera';
            case agent.indexOf('chrome') > -1 && !!window.chrome:
                return 'chrome';
            case agent.indexOf('trident') > -1:
                return 'ie';
            case agent.indexOf('firefox') > -1:
                return 'firefox';
            case agent.indexOf('safari') > -1:
                return 'safari';
            default:
                return 'other';
        }
    }
    /**
     * Validate the browser running is one that is supported and tested, othwerwise display a warning
     */
    validateBrowserAndWarn() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isSafariDesktop) {
                const toast = yield this.toastController.create({
                    buttons: [
                        {
                            icon: 'close',
                            role: 'cancel',
                        },
                    ],
                    color: 'warning',
                    duration: 600000,
                    message: '<b>Please use the Google <a href="https://www.google.com/chrome/">Chrome browser.</a></b>  The Safari browser is not supported by this application.  It may work, but certain versions have known issues and it is not tested.',
                });
                yield toast.present();
            }
        });
    }
};
BrowserDetectService.ctorParameters = () => [
    { type: Platform },
    { type: ToastController }
];
BrowserDetectService.ngInjectableDef = ɵɵdefineInjectable({ factory: function BrowserDetectService_Factory() { return new BrowserDetectService(ɵɵinject(Platform), ɵɵinject(ToastController)); }, token: BrowserDetectService, providedIn: "root" });
BrowserDetectService = __decorate([
    Injectable({
        providedIn: 'root'
    })
], BrowserDetectService);

let LoadingService = class LoadingService {
    constructor(platform, browserDetectService, splashScreen) {
        this.platform = platform;
        this.browserDetectService = browserDetectService;
        this.splashScreen = splashScreen;
        this.hidden = false;
        setTimeout(() => {
            if (!this.hidden) {
                this.hideLoadingScreen();
                console.log('Loading screen was not hidden after several seconds! Forceing it to hide');
            }
        }, 20000);
    }
    hideLoadingScreen() {
        this.hidden = true;
        if (this.browserDetectService.isNative) {
            this.platform.ready().then(() => {
                this.splashScreen.hide();
            });
        }
        document.body.classList.add('done-loading');
    }
};
LoadingService.ctorParameters = () => [
    { type: Platform },
    { type: BrowserDetectService },
    { type: SplashScreen }
];
LoadingService.ngInjectableDef = ɵɵdefineInjectable({ factory: function LoadingService_Factory() { return new LoadingService(ɵɵinject(Platform), ɵɵinject(BrowserDetectService), ɵɵinject(SplashScreen$1)); }, token: LoadingService, providedIn: "root" });
LoadingService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], LoadingService);

let ErrorHandlerService = class ErrorHandlerService {
    constructor(loadingService, modalController, debugService, toastController) {
        this.loadingService = loadingService;
        this.modalController = modalController;
        this.debugService = debugService;
        this.toastController = toastController;
        this.errorModalDataList = [];
        this.toastList = [];
    }
    clearToasts() {
        for (const toast of this.toastList) {
            toast.dismiss();
        }
        this.toastList.length = 0;
    }
    error(message, data) {
        this.errorWithFeedback(message, undefined, undefined, data);
    }
    errorWithFeedback(message, buttonIcon, buttonHandler, data) {
        console.log(message);
        if (data) {
            console.log(data);
        }
        return this.presentToast(message, data, 'danger', buttonIcon, buttonHandler);
    }
    warning(message, data) {
        console.log(message);
        if (data) {
            console.log(data);
        }
        if (this.debugService.isDebug) {
            this.presentToast(message, data, 'warning');
        }
    }
    info(message, data) {
        console.log(message);
        if (data) {
            console.log(data);
        }
    }
    logErrorResponse(errorResponse, request, operation, url) {
        console.log(errorResponse);
        // const data = {
        //   url: url,
        //   request: request,
        //   operation: operation,
        //   errorResponse: errorResponse
        // };
        //
        // const inferredMethodName = this.extractServiceName(request);
        //
        //
        // let errorCode;
        // if (data.errorResponse && data.errorResponse.Status) {
        //   errorCode = data.errorResponse.Status.Code;
        // }
        //
        // let exceptionTitle;
        // if (inferredMethodName) {
        //   exceptionTitle = errorCode + ' - ' + inferredMethodName;
        // } else {
        //   exceptionTitle = errorCode + ' - ' + data.url;
        // }
        //
        // // Add the description tot the title if we have one
        // if (errorResponse && errorResponse.Status) {
        //   if (errorResponse.Status.AddtionalDetails && errorResponse.Status.AddtionalDetails.Status) {
        //     exceptionTitle += ' ' + errorResponse.Status.AddtionalDetails.Status.Description;
        //   } else if (errorResponse.Status.Description) {
        //     exceptionTitle += + ' ' + errorResponse.Status.Description;
        //   }
        // }
        //
        //
        //
        // let fingerprint = [
        //   inferredMethodName,
        //   errorCode,
        //   data.url
        // ];
        //
        // if (errorCode === 'HTTPErrorCode0') {
        //   fingerprint = ['HTTPErrorCode0'];
        //   exceptionTitle = 'Connection was offline!';
        //   if (inferredMethodName) {
        //     exceptionTitle += ' - ' + inferredMethodName;
        //   }
        // }
        // if (Raven.isSetup()) {
        //     Raven.captureMessage(exceptionTitle, {
        //         extra: data,
        //         fingerprint: fingerprint
        //     });
        //
        //     return Raven.lastEventId();
        // }
    }
    showErrorDialog(errorResponse, request, operation, url) {
        debugger;
        const data = {
            url: url,
            request: request,
            operation: operation,
            serviceResponse: errorResponse
        };
        this.logErrorResponse(errorResponse, request, operation, url);
        this.errorModalDataList.push(data);
        if (!this.errorModal) {
            this.errorModal = 'initializing';
            this.modalController.create({
                component: ErrorHandlerDialogComponent,
                animated: true,
                showBackdrop: true,
                backdropDismiss: true,
                cssClass: 'asm-modal-sub',
                componentProps: {
                    errorList: this.errorModalDataList,
                },
            }).then((popover) => {
                this.errorModal = popover;
                this.errorModal.present();
                this.errorModal.onDidDismiss().then(() => {
                    this.errorModal = undefined;
                });
            });
        }
    }
    presentToast(message, data, color = 'danger', buttonIcon, buttonHandler) {
        return __awaiter(this, void 0, void 0, function* () {
            const toast = yield this.toastController.create({
                buttons: [
                    {
                        handler: buttonHandler,
                        icon: buttonIcon,
                    }, {
                        icon: 'close',
                        role: 'cancel',
                    },
                ],
                color,
                duration: 600000,
                message,
            });
            yield toast.present();
            // In case the loading overlay is showing, hide it to show the toast
            this.loadingService.hideLoadingScreen();
            this.toastList.push(toast);
            return toast;
        });
    }
};
ErrorHandlerService.ctorParameters = () => [
    { type: LoadingService },
    { type: ModalController },
    { type: DebugService },
    { type: ToastController }
];
ErrorHandlerService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ErrorHandlerService_Factory() { return new ErrorHandlerService(ɵɵinject(LoadingService), ɵɵinject(ModalController), ɵɵinject(DebugService), ɵɵinject(ToastController)); }, token: ErrorHandlerService, providedIn: "root" });
ErrorHandlerService = __decorate([
    Injectable({
        providedIn: 'root'
    })
], ErrorHandlerService);

let StudentViewService = class StudentViewService {
    constructor(errorHandlerService) {
        this.errorHandlerService = errorHandlerService;
        // This keeps track of the current student view be it video or document
        this.studentViewSubject = new ReplaySubject(1);
        this.studentView$ = this.studentViewSubject.asObservable();
        this.studentView = { studentViewType: StudentViewType.none, rate: 1,
            orientation: PhoneOrientation.portrait, width: 320, height: 568 };
        this.refreshDocumentEvent = new EventEmitter();
    }
    refreshDocument() {
        this.refreshDocumentEvent.emit(this.studentView.studentDocument);
    }
    clearVideoState(studentView) {
        studentView.video = undefined;
        studentView.loadingState = VideoLoadingState.unknown;
        studentView.playbackState = VideoPlaybackState.unknown;
        studentView.rate = 1.0;
        studentView.time = 0.0;
    }
    clearDocumentState(studentView) {
        studentView.studentDocument = undefined;
    }
    getDocumentUrl(studentDocument, renderMode, useCorsProxy) {
        let url;
        if (studentDocument.type === 'PDF' || studentDocument.pdfUrl) {
            url = studentDocument.pdfUrl;
        }
        else {
            switch (renderMode) {
                case 'pdf':
                    if (studentDocument.storageId) {
                        url = `https://docs.google.com/document/d/${studentDocument.storageId}/export?format=pdf`;
                    }
                    else if (studentDocument.url) {
                        url = studentDocument.url;
                    }
                    else {
                        this.errorHandlerService.error(`Unsupported document type (${studentDocument.type}) for ${studentDocument.name} ${studentDocument.url}`);
                    }
                    break;
                case 'preview':
                    url = `https://docs.google.com/document/d/${studentDocument.storageId}/preview?rm=minimal`;
                    break;
                case 'edit':
                default:
                    url = `https://docs.google.com/document/d/${studentDocument.storageId}/edit?usp=sharing`;
                    break;
            }
        }
        if (useCorsProxy) {
            url = 'https://cors-anywhere.herokuapp.com/' + url;
        }
        return url;
    }
    applyToStudentView(studentViewProperties, dontSignalChange = false) {
        if (studentViewProperties) {
            for (const property in studentViewProperties) {
                if (studentViewProperties.hasOwnProperty(property)) {
                    this.studentView[property] = studentViewProperties[property];
                }
            }
        }
        if (!dontSignalChange) {
            this.studentViewSubject.next(this.studentView);
        }
    }
    /**
     * Set the current playing stream that the student sees
     * @param studentViewType The type of view
     * @param viewData Either a StudentDocument or Video that the student sees
     */
    setStudentView(studentViewType, viewData) {
        this.studentView.studentViewType = studentViewType;
        if (studentViewType === StudentViewType.documentStream) {
            if (!viewData.clientStatus ||
                !this.studentView.studentDocument ||
                this.studentView.studentDocument.url !== viewData.url) {
                viewData.clientStatus = StudentDocumentLoadingStatus.loading;
            }
            this.studentView.streamId = undefined;
            this.clearVideoState(this.studentView);
            this.studentView.studentDocument = viewData;
            if (this.studentView.studentDocument.pageNumber < 1 || !this.studentView.studentDocument.pageNumber) {
                this.studentView.studentDocument.pageNumber = 1;
            }
            else if (this.studentView.studentDocument.pageNumber > this.studentView.studentDocument.pageCount) {
                this.studentView.studentDocument.pageNumber = this.studentView.studentDocument.pageCount;
            }
        }
        else if (studentViewType === StudentViewType.videoStream) {
            this.studentView.streamId = undefined;
            this.clearDocumentState(this.studentView);
            this.studentView.video = viewData;
        }
        else {
            this.clearVideoState(this.studentView);
            this.clearDocumentState(this.studentView);
        }
        if (studentViewType === StudentViewType.callStream || studentViewType === StudentViewType.screenshareStream) {
            this.studentView.streamId = viewData.streamId;
        }
        // this.layoutService.updateStudentView(this.studentView);
        this.studentViewSubject.next(this.studentView);
    }
    applyPageCount(pageCount) {
        if (this.studentView.studentViewType === StudentViewType.documentStream) {
            this.studentView.studentDocument.pageCount = pageCount;
            this.studentViewSubject.next(this.studentView);
        }
        else {
            this.errorHandlerService.warning('Could not set page count because the current view is not a document!');
        }
    }
};
StudentViewService.ctorParameters = () => [
    { type: ErrorHandlerService }
];
StudentViewService.ngInjectableDef = ɵɵdefineInjectable({ factory: function StudentViewService_Factory() { return new StudentViewService(ɵɵinject(ErrorHandlerService)); }, token: StudentViewService, providedIn: "root" });
StudentViewService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], StudentViewService);

let StudentDocViewerComponent = class StudentDocViewerComponent {
    constructor(studentViewService, debugService) {
        this.studentViewService = studentViewService;
        this.debugService = debugService;
        this.loadingChange = new EventEmitter();
        this.pageCount = new EventEmitter();
        this.onDownloadProgress = new EventEmitter();
        this.cachedDocuments = [];
    }
    ngOnInit() {
        this.scrollBarWidth = 20;
        this.refreshDocumentSubscription = this.studentViewService.refreshDocumentEvent.subscribe(() => {
            if (this.document) {
                const cachedDocument = this.getCachedDocument(this.document.url);
                if (cachedDocument) {
                    const currentDocUrl = cachedDocument.url;
                    cachedDocument.url = '';
                    setTimeout(() => {
                        cachedDocument.url = currentDocUrl;
                        cachedDocument.studentDocument.pageNumber = this.document.pageNumber;
                    }, 0);
                }
            }
        });
    }
    onProgress(progressData) {
        this.progressData = progressData;
        this.onDownloadProgress.emit(progressData);
    }
    onError(err) {
        this.error = err;
        this.loading = false;
    }
    ngOnDestroy() {
        if (this.refreshDocumentSubscription) {
            this.refreshDocumentSubscription.unsubscribe();
        }
    }
    afterLoadComplete($event, cachedDocument) {
        if ($event && $event._pdfInfo) {
            cachedDocument.studentDocument.pageCount = parseInt($event._pdfInfo.numPages, 10);
            if (this.document && cachedDocument.studentDocument.url === this.document.url) {
                this.pageCount.emit(cachedDocument.studentDocument.pageCount);
            }
            this.loading = false;
            this.loadingChange.emit(this.loading);
        }
    }
    getCachedDocument(url) {
        for (const doc of this.cachedDocuments) {
            if (doc.studentDocument.url === url) {
                return doc;
            }
        }
    }
    getCachedDocumentIndex(url) {
        for (let i = 0; i < this.cachedDocuments.length; i++) {
            const doc = this.cachedDocuments[i];
            if (doc.studentDocument.url === url) {
                return i;
            }
        }
        return -1;
    }
    ngOnChanges(changes) {
        if (changes.document) {
            if (this.document) {
                const cachedDocument = this.getCachedDocument(this.document.url);
                if (!cachedDocument) {
                    this.cachedDocuments.push({
                        studentDocument: this.document,
                        url: this.studentViewService.getDocumentUrl(this.document, 'pdf', true),
                    });
                    this.loading = true;
                    this.loadingChange.emit(this.loading);
                }
                else {
                    const docIndex = this.getCachedDocumentIndex(this.document.url);
                    if (docIndex >= 0) {
                        this.cachedDocuments[docIndex].studentDocument = this.document;
                    }
                }
                // this.documentUrl =  'https://docs.google.com/document/d/1bEEOA9_jJKyVlWxHxReEoZn0ReZqp5vA7SVrJ7c_3rE/export?format=pdf';
            }
        }
        if (changes.documentCacheList && this.documentCacheList && this.documentCacheList.length > 0) {
            for (const newDocument of this.documentCacheList) {
                if (!this.getCachedDocument(newDocument.url)) {
                    this.cachedDocuments.push({
                        studentDocument: newDocument,
                        url: this.studentViewService.getDocumentUrl(newDocument, 'pdf', true),
                    });
                    console.log(`Cached document ${newDocument.name}`);
                }
            }
        }
        // if (changes.page) {
        //   this.page2 = 13 + this.page;
        //   // this.page2 = this.page;
        // }
    }
};
StudentDocViewerComponent.ctorParameters = () => [
    { type: StudentViewService },
    { type: DebugService }
];
__decorate([
    Input()
], StudentDocViewerComponent.prototype, "screenWidth", void 0);
__decorate([
    Input()
], StudentDocViewerComponent.prototype, "screenHeight", void 0);
__decorate([
    Input()
], StudentDocViewerComponent.prototype, "document", void 0);
__decorate([
    Input()
], StudentDocViewerComponent.prototype, "loading", void 0);
__decorate([
    Output()
], StudentDocViewerComponent.prototype, "loadingChange", void 0);
__decorate([
    Input()
], StudentDocViewerComponent.prototype, "documentCacheList", void 0);
__decorate([
    Output()
], StudentDocViewerComponent.prototype, "pageCount", void 0);
__decorate([
    Output()
], StudentDocViewerComponent.prototype, "onDownloadProgress", void 0);
StudentDocViewerComponent = __decorate([
    Component({
        selector: 'app-student-doc-viewer',
        template: "<!--Google Docs URL parameters:-->\n<!--rm=minimal-->\n<!--rm=full-->\n<!--rm=embedded-->\n<!--rm=demo-->\n<!--rm=(render mode)-->\n<!--ui=2 (select the interface version)-->\n<!--chrome=false (full screen mode)-->\n<!--gid=24 (Whis sheet you want to display)-->\n<!--widget=false-->\n<!--single=true-->\n<!--range=A2:AA26 Output=html-->\n<!--widget=false-->\n<!--width=(width)-->\n<!--height=(height)-->\n<!--frameborder=(size of border)-->\n<!--q=(Whatever) Search Query-->\n<!--viewer?-->\n<!--start=-->\n<!--channel=-->\n<!--ibd=-->\n<!--client=-->\n<div class=\"iframe-wrapper\" *ngIf=\"cachedDocuments.length > 0\"\n     [ngStyle]=\"{'visibility': document ? 'visible': 'hidden', width: screenWidth + 'px', height: screenHeight + 'px'}\">\n<!--    <div class=\"debug-loading-status\" *ngIf=\"debugService.isDebug\">-->\n<!--        Loading: {{loading}}-->\n<!--        <pre>-->\n<!--            {{progressData|json}}-->\n<!--        </pre>-->\n<!--        <pre>-->\n<!--            {{error|json}}-->\n<!--        </pre>-->\n<!--        {{screenWidth + ' x ' + screenHeight}}-->\n<!--    </div>-->\n\n\n    <div class=\"loading-area\" *ngIf=\"loading\">\n        <div>\n            <ion-text color=\"light\" class=\" loading-text ion-text-center\">\n                Loading document<br/>\n            </ion-text>\n        <div>\n            <ion-progress-bar color=\"light\" type=\"indeterminate\"></ion-progress-bar>\n        </div>\n        </div>\n        <!--    <img class=\"vertue-logo\" src=\"/vertue-workspace/projects/vertue-student/src/assets/vertue_logo_large.png\">-->\n        <!--    <img class=\"vertue-logo-text\" src=\"/vertue-workspace/projects/vertue-student/src/assets/vertue_logo_text.png\">-->\n\n    </div>\n    <div style=\"position: relative;\"\n         [ngStyle]=\"{width: screenWidth + 'px', height: screenHeight + 'px'}\">\n<!---->\n        <pdf-viewer\n                *ngFor=\"let cachedDocument of cachedDocuments\"\n                    [src]=\"cachedDocument.url\"\n                    [zoom]=\"1\"\n                    [zoom-scale]=\"'page-fit'\"\n                    [original-size]=\"false\"\n                    [show-all]=\"false\"\n                    [show-borders]=\"false\"\n                    [autoresize]=\"true\"\n                    [ngStyle]=\"{'visibility': (document && cachedDocument.studentDocument.url === document.url) ? 'visible': 'hidden',\n                                'width': screenWidth + 'px',\n                                'max-width': screenWidth + 'px',\n                                'height': screenHeight + 'px',\n                                'max-height': screenHeight + 'px',\n                                'display': 'block'}\"\n                    [(page)]=\"cachedDocument.studentDocument.pageNumber\"\n                    (on-progress)=\"onProgress($event)\"\n                    (on-error)=\"onError($event)\"\n                    (after-load-complete)=\"afterLoadComplete($event, cachedDocument)\"\n\n\n        ></pdf-viewer>\n    </div>\n</div>\n",
        styles: [".iframe-wrapper{background-color:#01c180;display:flex;flex-direction:column;justify-content:center}pdf-viewer{position:absolute;left:0;right:0;top:0;bottom:0}.debug-loading-status{position:absolute;top:10px;left:10px;right:10px;background-color:rgba(0,0,0,.25);color:#fff;padding:10px;border-radius:10px;z-index:10000}.loading-text{line-height:25px}:host ::ng-deep .pdfViewer.removePageBorders .page{margin-bottom:0!important}"]
    })
], StudentDocViewerComponent);

var VertueCommonModule_1;
let VertueCommonModule = VertueCommonModule_1 = class VertueCommonModule {
    constructor() {
        //@Optional() @SkipSelf() parentModule?: VertueCommonModule
        // if (parentModule) {
        //     throw new Error(
        //         'VertueCommonModule is already loaded. Import it in the AppModule only');
        // }
    }
    static forRoot(config) {
        return {
            ngModule: VertueCommonModule_1,
            providers: [
                { provide: VertueServiceConfig, useValue: config }
            ]
        };
    }
};
VertueCommonModule = VertueCommonModule_1 = __decorate([
    NgModule({
        declarations: [
            ErrorHandlerDialogComponent,
            PhoneNumberPipe,
            StudentDocViewerComponent,
        ],
        entryComponents: [
            StudentDocViewerComponent,
            ErrorHandlerDialogComponent,
        ],
        exports: [
            StudentDocViewerComponent,
            ErrorHandlerDialogComponent,
            PhoneNumberPipe,
        ],
        imports: [
            CommonModule,
            IonicModule,
            PdfViewerModule,
        ],
    })
], VertueCommonModule);

let LocalStorageService = class LocalStorageService {
    constructor() {
        this.fallback = {};
        this.hasLocalStorageSupport = undefined;
        this.hasSessionStorageSupport = undefined;
    }
    checkStorageSupport() {
        if (this.hasLocalStorageSupport === undefined) {
            try {
                if (window.localStorage && window.localStorage.setItem) {
                    window.localStorage.setItem('__TESTKEY__', '1');
                    window.localStorage.getItem('__TESTKEY__');
                    window.localStorage.removeItem('__TESTKEY__');
                    this.hasLocalStorageSupport = true;
                }
                else {
                    this.hasLocalStorageSupport = false;
                    console.log('Local storage not available');
                }
            }
            catch (e) {
                console.log('Local storage exception');
                this.hasLocalStorageSupport = false;
            }
            try {
                if (window.sessionStorage && window.sessionStorage.setItem) {
                    window.sessionStorage.setItem('__TESTKEY__', '1');
                    window.sessionStorage.getItem('__TESTKEY__');
                    window.sessionStorage.removeItem('__TESTKEY__');
                    this.hasSessionStorageSupport = true;
                }
                else {
                    console.log('Session storage not available');
                    this.hasSessionStorageSupport = false;
                }
            }
            catch (e) {
                console.log('Session storage exception');
                this.hasSessionStorageSupport = false;
            }
        }
    }
    /**
     * Set an item into local storage, fallback to session storage, then to just an object depending on access
     * @param {string} key
     * @param {string} value
     */
    setItem(key, value, forceSessionStorage = false) {
        this.checkStorageSupport();
        if (this.hasLocalStorageSupport && !forceSessionStorage) {
            window.localStorage.setItem(key, value);
        }
        else if (this.hasSessionStorageSupport) {
            window.sessionStorage.setItem(key, value);
        }
        else {
            this.fallback[key] = value;
        }
    }
    /**
     * Get an item from local storage if we have support, otherwise we go to session storage, then just an immemory object
     * @param {string} key
     * @returns {string}
     */
    getItem(key, forceSessionStorage = false) {
        this.checkStorageSupport();
        if (this.hasLocalStorageSupport && !forceSessionStorage) {
            // console.log('Using local storage for ' + key);
            return window.localStorage.getItem(key);
        }
        else if (this.hasSessionStorageSupport) {
            // console.log('Using SESSION storage for ' + key);
            return window.sessionStorage.getItem(key);
        }
        else {
            // console.log('Using fallback storage for ' + key);
            return this.fallback[key];
        }
    }
    /**
     * Convert the specified object to a JSON string, then store it in localstorage
     * @param key
     * @param value
     * @param forceSessionStorage
     */
    setObject(key, value, forceSessionStorage = false) {
        this.setItem(key, JSON.stringify(value), forceSessionStorage);
    }
    /**
     * Get an item and parse it as a JSON object
     * @param key
     * @param forceSessionStorage
     */
    getObject(key, forceSessionStorage = false) {
        const stringItem = this.getItem(key);
        if (stringItem) {
            try {
                return JSON.parse(stringItem);
            }
            catch (e) {
                console.log(e);
                return undefined;
            }
        }
    }
    removeItem(key, forceSessionStorage = false) {
        this.checkStorageSupport();
        if (this.hasLocalStorageSupport && !forceSessionStorage) {
            window.localStorage.removeItem(key);
        }
        else if (this.hasSessionStorageSupport) {
            window.sessionStorage.removeItem(key);
        }
        else {
            this.fallback[key] = undefined;
            delete this.fallback[key];
        }
    }
    /**
     * Remove every key that contains partialKey in the key.  Does an exact case-sensitve match
     * @param partialKey
     * @param forceSessionStorage
     */
    removeKeysContaining(partialKey, forceSessionStorage = false) {
        const keysToRemove = [];
        this.forEach((key, value) => {
            if (key.indexOf(partialKey) >= 0) {
                keysToRemove.push(key);
            }
        }, forceSessionStorage);
        for (const keyToRemove of keysToRemove) {
            this.removeItem(keyToRemove);
        }
    }
    forEach(eachFn, forceSessionStorage = false) {
        this.checkStorageSupport();
        if (this.hasLocalStorageSupport && !forceSessionStorage) {
            for (let i = 0; i < localStorage.length; i++) {
                const storageKey = localStorage.key(i);
                const value = localStorage[i];
                eachFn(storageKey, value);
            }
        }
        else if (this.hasSessionStorageSupport) {
            for (let i = 0; i < sessionStorage.length; i++) {
                const storageKey = sessionStorage.key(i);
                const value = sessionStorage[i];
                eachFn(storageKey, value);
            }
        }
        else {
            for (const storageKey in this.fallback) {
                if (this.fallback.hasOwnProperty(storageKey)) {
                    const value = this.fallback[storageKey];
                    eachFn(storageKey, value);
                }
            }
        }
    }
};
LocalStorageService.ngInjectableDef = ɵɵdefineInjectable({ factory: function LocalStorageService_Factory() { return new LocalStorageService(); }, token: LocalStorageService, providedIn: "root" });
LocalStorageService = __decorate([
    Injectable({
        providedIn: 'root'
    })
], LocalStorageService);

const { Storage } = Plugins;
const { Browser } = Plugins;
let AuthService = class AuthService {
    constructor(router, platform, zone, browserDetectService, localStorageService, errorHandlerService, vertueServiceConfig) {
        this.router = router;
        this.platform = platform;
        this.zone = zone;
        this.browserDetectService = browserDetectService;
        this.localStorageService = localStorageService;
        this.errorHandlerService = errorHandlerService;
        this.isAuthenticatedSubject = new ReplaySubject(1);
        // Create a local property for login status
        this.isAuthenticated = undefined;
        // Create subject and public observable of user profile data
        this.userProfileSubject$ = new BehaviorSubject(null);
        this.userProfile$ = this.userProfileSubject$.asObservable();
        this.loading = true;
        this.vertueServiceConfig = vertueServiceConfig;
        this.isAuthenticated$ = this.isAuthenticatedSubject.asObservable();
        if (!this.browserDetectService.isNative) {
            console.log('Using browser version of auth service');
            let redirectUrl;
            if (this.browserDetectService.isNative) {
                redirectUrl = `com.vertue.student://vertue-dev.auth0.com/cordova/vertue-student/callback`;
                // redirectUrl = `http://localhost/cordova/vertue-student/callback`;
            }
            else {
                redirectUrl = `${window.location.origin}${this.vertueServiceConfig.vertueRedirectPath}`;
            }
            // Create an observable of Auth0 instance of client
            this.auth0Client$ = from(createAuth0Client({
                audience: this.vertueServiceConfig.auth0Audience,
                cacheLocation: 'localstorage',
                client_id: this.vertueServiceConfig.auth0ClientIdWeb,
                domain: this.vertueServiceConfig.auth0Domain,
                redirect_uri: redirectUrl,
                useRefreshTokens: true,
            })).pipe(shareReplay(1), // Every subscription receives the same shared value
            catchError((err) => {
                return throwError(err);
            }));
            this.auth0Client$.subscribe((client) => {
                client.isAuthenticated().then((isAuthenticated) => {
                    if (this.isAuthenticated !== isAuthenticated) {
                        this.isAuthenticated = isAuthenticated;
                        this.isAuthenticatedSubject.next(this.isAuthenticated);
                    }
                });
            }, (err) => {
                this.errorHandlerService.errorWithFeedback('Could not initialize authentication client.  Are you already logged in with another browser session?', 'refresh', () => {
                    this.logout();
                }, err);
            });
            this.handleRedirectCallback$ = this.auth0Client$.pipe(concatMap((client) => from(client.handleRedirectCallback())));
            if (typeof (Plugins) !== 'undefined') {
                this.auth0Client$.pipe(first()).subscribe((client) => {
                    console.log('Got auth client');
                    Plugins.App.addListener('appUrlOpen', (urlOpen) => {
                        if (urlOpen.url && this.platform.is('hybrid')) {
                            Browser.close();
                        }
                        console.log(`URL: ${urlOpen.url}`);
                        setTimeout(() => {
                            client.handleRedirectCallback(urlOpen.url).then((callbackResponse) => {
                                console.log('handling redirect callback' + callbackResponse.appState.target);
                                let targetRoute; // Path to redirect to after login processsed
                                // Get and set target redirect route from callback results
                                targetRoute = callbackResponse.appState && callbackResponse.appState.target ? callbackResponse.appState.target : '/';
                                // this.authToken$ = from(client.getTokenSilently());
                                //
                                // this.authToken$.pipe(first()).subscribe((token) => {
                                //     this.authToken = token;
                                // });
                                combineLatest([
                                    this.getUser$(),
                                    this.getAuthToken$(),
                                    this.isAuthenticated$,
                                ]).pipe(first()).subscribe(() => {
                                    this.router.navigate([targetRoute]);
                                });
                            }, (err) => {
                                console.log('Unable to handle Auth0 redirect call back.  This likely means the Allowed Origins (CORS) has not been set in Auth0.  Look for other CORS errors to confirm this');
                                console.log(err);
                            });
                        }, 0);
                    });
                });
            }
            // On initial load, check authentication state with authorization server
            // Set up local auth streams if user is already authenticated
            // this.l¬ocalAuthSetup();
            // Handle redirect from Auth0 login
            this.handleAuthCallback();
        }
    }
    nativeInit(NativeWebAuth, NativeAuth0Cordova) {
        if (!this.browserDetectService.isNative) {
            return;
        }
        // console.log('Set safari view controller to Browser');
        // (window as any).SafariViewController = Browser;
        console.log('Mapping handleOpenURL');
        window.handleOpenURL = (url) => {
            console.log('Calling NativeAuth0Cordova.onRedirectUri');
            NativeAuth0Cordova.onRedirectUri(url);
            if (url.indexOf('/signedout') >= 0) {
                this.router.navigate(['/signedout']);
            }
        };
        const AUTH_CONFIG = {
            // Needed for Auth0 (capitalization: ID):
            clientID: this.vertueServiceConfig.auth0ClientIdNative,
            // Needed for Auth0Cordova (capitalization: Id):
            clientId: this.vertueServiceConfig.auth0ClientIdNative,
            domain: 'vertue-dev.auth0.com',
            callbackURL: location.href,
            packageIdentifier: 'com.vertue.student',
        };
        this.Auth0 = new NativeWebAuth(AUTH_CONFIG);
        this.Client = new NativeAuth0Cordova(AUTH_CONFIG);
        console.log('Attempting native auth');
        this.getStorageObject('profile').then((profile) => {
            this.userProfileSubject$.next(profile);
        });
        this.getStorageObject('access_token').then((authToken) => {
            this.authToken = authToken;
            this.validateAuth();
        });
        this.getStorageObject('expires_at').then((expiresAt) => {
            this.expiresAt = expiresAt;
            this.validateAuth();
        });
    }
    /**
     * Verify we both have an auth token and that it is not expired.
     */
    validateAuth() {
        const isExpired = Date.now() > this.expiresAt;
        if (isExpired) {
            this.authToken = undefined;
            if (this.isAuthenticated) {
                this.isAuthenticated = false;
                this.isAuthenticatedSubject.next(this.isAuthenticated);
            }
        }
        else if (this.authToken) {
            if (!this.isAuthenticated) {
                this.isAuthenticated = true;
                this.isAuthenticatedSubject.next(this.isAuthenticated);
                this.loading = false;
            }
        }
        else {
            this.isAuthenticated = false;
            this.isAuthenticatedSubject.next(this.isAuthenticated);
        }
    }
    getStorageObject(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield Storage.get({ key });
            if (result && result.value) {
                try {
                    return JSON.parse(result.value);
                }
                catch (e) {
                }
            }
        });
    }
    // When calling, options can be passed if desired
    // https://auth0.github.io/auth0-spa-js/classes/auth0client.html#getuser
    getUser$(options) {
        return this.auth0Client$.pipe(concatMap((client) => from(client.getUser(options))), tap((user) => this.userProfileSubject$.next(user)));
    }
    getAuthToken$(options) {
        if (this.authToken) {
            return of(this.authToken);
        }
        else {
            if (this.browserDetectService.isNative) {
                return this.isAuthenticated$.pipe(map((isAuthenticated) => {
                    return this.authToken;
                }));
            }
            else {
                return this.auth0Client$.pipe(concatMap((client) => from(client.getTokenSilently(options))), tap((token) => {
                    this.authToken = token;
                }));
            }
        }
    }
    login(redirectPath = '/') {
        // Make sure we are always on the login page before signing in
        this.router.navigate(['/signedout']);
        if (this.browserDetectService.isNative) {
            this.loginNative(redirectPath);
        }
        else {
            this.loginWeb(redirectPath);
        }
    }
    loginNative(redirectPath) {
        this.loading = true;
        const options = {
            audience: this.vertueServiceConfig.auth0Audience,
            scope: 'openid profile offline_access',
        };
        console.log('Calling Client.authorize');
        // Authorize login request with Auth0: open login page and get auth results
        this.Client.authorize(options, (err, authResult) => {
            if (err) {
                this.zone.run(() => this.loading = false);
                throw err;
            }
            else {
                console.log('Client.authorize successful');
            }
            // Set access token
            Storage.set({ key: 'access_token', value: JSON.stringify(authResult.accessToken) });
            this.authToken = authResult.accessToken;
            // Set access token expiration
            const expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
            Storage.set({ key: 'expires_at', value: expiresAt });
            // Set logged in
            this.loading = false;
            this.isAuthenticated = true;
            this.isAuthenticatedSubject.next(this.isAuthenticated);
            // Fetch user's profile info
            this.Auth0.client.userInfo(this.authToken, (errUserInfo, profile) => {
                if (err) {
                    throw err;
                }
                Storage.set({ key: 'profile', value: JSON.stringify(profile) }).then((val) => {
                    this.zone.run(() => {
                        this.userProfileSubject$.next(profile);
                    });
                });
            });
            console.log(`Redirect to ${this.vertueServiceConfig.vertueRedirectPath}...`);
            this.router.navigate([this.vertueServiceConfig.vertueRedirectPath]);
        });
    }
    loginWeb(redirectPath) {
        // A desired redirect path can be passed to login method
        // (e.g., from a route guard)
        // Ensure Auth0 client instance exists
        const authConfig = {
            appState: { target: redirectPath },
        };
        this.auth0Client$.subscribe((client) => {
            if (false && this.platform.is('hybrid')) {
                console.log('Using inAppBrowser for native');
                // Call method to log in
                client.buildAuthorizeUrl(authConfig).then((url) => {
                    Browser.open({
                        presentationStyle: 'popover',
                        url,
                    }).then((res) => {
                        const b = Browser;
                        console.log('Browser.open complete');
                        console.log(res);
                    });
                });
            }
            else {
                console.log('Launching auth using standard window url');
                client.loginWithRedirect(authConfig);
            }
            // window.location.assign(url);
            // client.loginWithRedirect({
            //     appState: {target: redirectPath},
            //     redirect_uri: this.redirectUrl,
            // });
        });
    }
    handleAuthCallback() {
        // Call when app reloads after user logs in with Auth0
        const params = window.location.search;
        if (params.includes('code=') && params.includes('state=')) {
            let targetRoute; // Path to redirect to after login processsed
            //
            // this.auth0Client$.pipe(first()).subscribe((client) => {
            //     client.handleRedirectCallback().then((callbackResponse) => {
            //
            //         // Get and set target redirect route from callback results
            //         targetRoute = callbackResponse.appState && callbackResponse.appState.target ? callbackResponse.appState.target : '/';
            //
            //         // this.authToken$ = from(client.getTokenSilently());
            //         //
            //         // this.authToken$.pipe(first()).subscribe((token) => {
            //         //     this.authToken = token;
            //         // });
            //         combineLatest([
            //             this.getUser$(),
            //             this.getAuthToken$(),
            //             this.isAuthenticated$,
            //
            //         ]).pipe(first()).subscribe(() => {
            //
            //             this.router.navigate([targetRoute]);
            //         });
            //
            //     });
            // });
            const authComplete$ = this.handleRedirectCallback$.pipe(
            // Have client, now call method to handle auth callback redirect
            tap((cbRes) => {
                // Get and set target redirect route from callback results
                targetRoute = cbRes.appState && cbRes.appState.target ? cbRes.appState.target : '/';
            }), concatMap(() => {
                // Redirect callback complete; get user and login status
                return combineLatest([
                    this.getUser$(),
                    this.isAuthenticated$,
                    this.getAuthToken$(),
                ]);
            }));
            // Subscribe to authentication completion observable
            // Response will be an array of user and login status
            authComplete$.subscribe(([user, isAuthenticated]) => {
                // Redirect to target route after callback processing
                this.router.navigate([targetRoute]);
            });
        }
        // else {
        //     this.auth0Client$.pipe(first()).subscribe((client) => {
        //         client.getTokenSilently({
        //             audience: 'https://api.vertue.com/coach/'
        //         }).then((token) => {
        //             this.jstToken = token;
        //         });
        //
        //     });
        // }
    }
    logout() {
        const me = this;
        this.localStorageService.removeKeysContaining('auth0');
        if (this.browserDetectService.isNative) {
            Storage.remove({ key: 'access_token' });
            Storage.remove({ key: 'expires_at' });
            Storage.remove({ key: 'profile' });
            const c = this.Client;
            // Call method to log out
            const logoutUrl = this.Client.client.buildLogoutUrl({
                client_id: this.vertueServiceConfig.auth0ClientIdNative,
                returnTo: `com.vertue.student://vertue-dev.auth0.com/signedout`,
            });
            Browser.open({
                presentationStyle: 'fullscreen',
                url: logoutUrl,
            }).then((res) => {
                const b = Browser;
                console.log('Browser.open complete');
                console.log(res);
                me.isAuthenticated = false;
                me.isAuthenticatedSubject.next(me.isAuthenticated);
            });
            this.router.navigate(['/signedout']);
        }
        else {
            // Ensure Auth0 client instance exists
            this.auth0Client$.subscribe((client) => {
                // Call method to log out
                client.logout({
                    client_id: this.vertueServiceConfig.auth0ClientIdWeb,
                    returnTo: `${window.location.origin}/signedout`,
                });
            });
        }
    }
};
AuthService.ctorParameters = () => [
    { type: Router },
    { type: Platform },
    { type: NgZone },
    { type: BrowserDetectService },
    { type: LocalStorageService },
    { type: ErrorHandlerService },
    { type: VertueServiceConfig, decorators: [{ type: Optional }] }
];
AuthService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(ɵɵinject(Router), ɵɵinject(Platform), ɵɵinject(NgZone), ɵɵinject(BrowserDetectService), ɵɵinject(LocalStorageService), ɵɵinject(ErrorHandlerService), ɵɵinject(VertueServiceConfig, 8)); }, token: AuthService, providedIn: "root" });
AuthService = __decorate([
    Injectable({
        providedIn: 'root',
    }),
    __param(6, Optional())
], AuthService);

let AuthGuard = class AuthGuard {
    constructor(auth) {
        this.auth = auth;
    }
    canActivate(next, state) {
        // return this.auth.getUser$().pipe(tap(user => {
        //   console.log(user);
        //   debugger;
        // }));
        return this.auth.isAuthenticated$.pipe(tap((loggedIn) => {
            if (!loggedIn) {
                const params = window.location.search;
                if (params.includes('code=') && params.includes('state=')) {
                    // Quick hack to wait for authentication to try and log us in
                    setTimeout(() => {
                        // Still not logged in, force us to do it
                        if (!this.auth.isAuthenticated) {
                            this.auth.login(state.url);
                        }
                    }, 1500);
                }
                else {
                    this.auth.login(state.url);
                }
            }
        }));
    }
};
AuthGuard.ctorParameters = () => [
    { type: AuthService }
];
AuthGuard.ngInjectableDef = ɵɵdefineInjectable({ factory: function AuthGuard_Factory() { return new AuthGuard(ɵɵinject(AuthService)); }, token: AuthGuard, providedIn: "root" });
AuthGuard = __decorate([
    Injectable({
        providedIn: 'root',
    })
], AuthGuard);

let GetUserMediaSupportService = class GetUserMediaSupportService {
    constructor(errorHandlerService) {
        this.errorHandlerService = errorHandlerService;
    }
    /**
     * Initialize call to precache user media support so its immediatly avaialble when getSupport is called
     * @returns {Promise<UserMediaSupport>}
     */
    init() {
        return this.getSupport();
    }
    promptForPermission() {
        const promise = new Promise((resolve, reject) => {
            navigator.mediaDevices.getUserMedia(
            // constraints
            {
                audio: true,
                video: true,
            }).then((localMediaStream) => {
                resolve(true);
            }, 
            // errorCallback
            (err) => {
                resolve(false);
            });
        });
        return promise;
    }
    /**
     * Returns a promise that resolves to true if the device has a web cam
     * @returns {Promise<boolean>}
     */
    getSupport() {
        const me = this;
        const promise = new Promise((resolve, reject) => {
            if (!navigator || !navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
                if (navigator && navigator.enumerateDevices) {
                    reject({
                        errorCode: 'noOldAPISupport',
                        errorMessage: 'Only old version of enumerate devices api exists!',
                    });
                }
                else {
                    reject({
                        errorCode: 'noAPISupport',
                        errorMessage: 'Could not find the enumerate devices api!',
                    });
                }
                return;
            }
            const isHTTPs = location.protocol === 'https:';
            const isLocalhost = location.hostname === 'localhost';
            if (!isHTTPs && !isLocalhost) {
                reject({
                    errorCode: 'notHTTPS',
                    errorMessage: 'Only secure locations are supported for GetUserMedia!  Your location is (' + location.href + ')',
                });
                return;
            }
            if (me.userMediaSupport) {
                resolve(me.userMediaSupport);
            }
            try {
                navigator.mediaDevices.enumerateDevices().then((devices) => {
                    if (!me.userMediaSupport) {
                        me.userMediaSupport = {
                            webcam: false,
                            webcamUserGrantedPermission: false,
                            microphone: false,
                            microphoneUserGrantedPermission: false,
                            speakers: false,
                            speakersUserGrantedPermission: false,
                        };
                    }
                    devices.forEach((device) => {
                        if (device.kind === 'audioinput') {
                            me.userMediaSupport.microphone = true;
                            me.userMediaSupport.microphoneUserGrantedPermission = device.label !== '';
                        }
                        if (device.kind === 'audiooutput') {
                            me.userMediaSupport.speakers = true;
                            me.userMediaSupport.speakersUserGrantedPermission = device.label !== '';
                        }
                        if (device.kind === 'videoinput') {
                            me.userMediaSupport.webcam = true;
                            me.userMediaSupport.webcamUserGrantedPermission = device.label !== '';
                        }
                    });
                    resolve(me.userMediaSupport);
                });
            }
            catch (err) {
                this.errorHandlerService.error('Exception in enumerate devices API (' + err.message + ')', err);
            }
        });
        return promise;
    }
};
GetUserMediaSupportService.ctorParameters = () => [
    { type: ErrorHandlerService }
];
GetUserMediaSupportService.ngInjectableDef = ɵɵdefineInjectable({ factory: function GetUserMediaSupportService_Factory() { return new GetUserMediaSupportService(ɵɵinject(ErrorHandlerService)); }, token: GetUserMediaSupportService, providedIn: "root" });
GetUserMediaSupportService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], GetUserMediaSupportService);

let OpentokService = class OpentokService {
    constructor(platform, browserDetectService, errorHandlerService, androidPermissions, getUserMediaSupportService) {
        this.platform = platform;
        this.browserDetectService = browserDetectService;
        this.errorHandlerService = errorHandlerService;
        this.androidPermissions = androidPermissions;
        this.getUserMediaSupportService = getUserMediaSupportService;
        this.cameraPermissionStatus = {
            intializing: true,
            sessionActive: false,
            webcam: false,
            webcamUserGrantedPermission: false,
        };
        this.connectionCount = 0;
        this.openTokSessionSubject = new ReplaySubject(1);
        this.openTokSession$ = this.openTokSessionSubject.asObservable();
        this.hasPermissionSubject = new ReplaySubject(1);
        this.hasPermission$ = this.hasPermissionSubject.asObservable();
        if (!this.browserDetectService.isNative) {
            this.getUserMediaSupportService.getSupport().then((mediaSupport) => {
                this.cameraPermissionStatus.intializing = false;
                this.cameraPermissionStatus.webcam = mediaSupport.webcam;
                this.cameraPermissionStatus.webcamUserGrantedPermission = mediaSupport.webcamUserGrantedPermission;
                if (mediaSupport.webcam) {
                    if (!mediaSupport.webcamUserGrantedPermission) {
                        this.hasPermissionSubject.next(false);
                        this.pollForBrowserCameraSupport();
                    }
                    else {
                        this.hasPermissionSubject.next(true);
                    }
                }
                else {
                    this.hasPermissionSubject.next(false);
                    this.errorHandlerService.error('A supported camera was not found!  This application can not work without a camera.');
                }
            }, (err) => {
                this.hasPermissionSubject.next(false);
                this.errorHandlerService.error('Unable to query camera devices!', err);
            });
        }
    }
    /**
     * Query the browser navigator for media support
     */
    pollForBrowserCameraSupport() {
        const intervalId = setInterval(() => {
            this.getUserMediaSupportService.getSupport().then((mediaSupport) => {
                if (mediaSupport.webcamUserGrantedPermission) {
                    console.log('Camera support found!');
                    this.cameraPermissionStatus.webcamUserGrantedPermission = true;
                    this.hasPermissionSubject.next(true);
                    clearInterval(intervalId);
                    if (this.initializedRoom) {
                        this.retryInitalization(false);
                    }
                }
                else {
                    console.log('No camera support!');
                }
            });
        }, 1000);
    }
    get isConnected() {
        return this.connectionCount > 0;
    }
    getOT() {
        if (this.browserDetectService.isNative) {
            console.log('Using native version of OpenTok');
            return OT;
        }
        else {
            console.log('Using browser version of OpenTok');
            return OpenTokWeb;
        }
    }
    retryInitalization(force) {
        if (this.initializedRoom) {
            if (this.session && !force) {
                this.errorHandlerService.error('A session has already been successfully initialized!');
            }
            else {
                this.initSession(this.initializedRoom);
            }
        }
        else {
            this.errorHandlerService.error('Session initialization must be attempted before calling this function.');
        }
    }
    initSession(room) {
        const me = this;
        this.initializedRoom = room;
        if (this.browserDetectService.isNativeAndroid) {
            console.log('Checking permissions');
            Promise.all([
                this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.CAMERA),
                this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.MODIFY_AUDIO_SETTINGS),
                this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.RECORD_AUDIO),
            ]).then((result) => {
                this.cameraPermissionStatus.intializing = false;
                let hasAllPermissions = true;
                for (const perm of result) {
                    if (!perm.hasPermission) {
                        hasAllPermissions = false;
                    }
                }
                this.cameraPermissionStatus.webcam = this.cameraPermissionStatus.webcamUserGrantedPermission = hasAllPermissions;
                console.log('Has camera permission?' + hasAllPermissions);
                console.log(JSON.stringify(result));
                this.hasPermissionSubject.next(hasAllPermissions);
                if (!hasAllPermissions) {
                    console.log('requesting camera permission');
                    me.requestCameraPermission().then(() => {
                        me.startSession(room);
                    });
                }
                else {
                    me.startSession(room);
                }
            }, (err) => {
                console.log('error checking permissions for camaera');
                console.log(err);
                this.cameraPermissionStatus.webcam = this.cameraPermissionStatus.webcamUserGrantedPermission = false;
                me.requestCameraPermission().then(() => {
                    me.startSession(room);
                });
            });
        }
        else {
            if (this.cameraPermissionStatus.webcamUserGrantedPermission) {
                me.startSession(room);
            }
            else {
                this.requestCameraPermission();
            }
        }
        return this.openTokSession$;
    }
    requestCameraPermission() {
        const me = this;
        return new Promise((resolve, reject) => {
            if (me.browserDetectService.isNativeAndroid) {
                me.androidPermissions.requestPermissions([
                    me.androidPermissions.PERMISSION.CAMERA,
                    me.androidPermissions.PERMISSION.MODIFY_AUDIO_SETTINGS,
                    me.androidPermissions.PERMISSION.RECORD_AUDIO,
                ]).then((permissionResponse) => {
                    me.hasPermissionSubject.next(permissionResponse.hasPermission);
                    if (permissionResponse.hasPermission) {
                        this.cameraPermissionStatus.webcam = this.cameraPermissionStatus.webcamUserGrantedPermission = true;
                        resolve(true);
                    }
                    else {
                        this.cameraPermissionStatus.webcam = this.cameraPermissionStatus.webcamUserGrantedPermission = false;
                        reject();
                    }
                }, (errRequest) => {
                    this.cameraPermissionStatus.webcam = this.cameraPermissionStatus.webcamUserGrantedPermission = false;
                    me.errorHandlerService.error('Error requesting permissions for camera', errRequest);
                    me.hasPermissionSubject.next(false);
                    reject();
                });
            }
            else {
                this.getUserMediaSupportService.promptForPermission().then((response) => {
                    if (response) {
                        resolve(true);
                    }
                    else {
                        reject();
                    }
                });
            }
        });
    }
    startSession(room) {
        const me = this;
        this.session = this.getOT().initSession(room.apiKey, room.sessionId);
        this.session.on('connectionCreated', function (event) {
            if (!me.connectionCount) {
                me.connectionCount++;
            }
            else {
                me.connectionCount++;
            }
        });
        this.session.on('connectionDestroyed', function (event) {
            if (me.connectionCount === 1) {
                me.connectionCount--;
            }
            else {
                me.connectionCount--;
            }
        });
        this.token = room.token;
        console.log(`this.apiKey = \'${room.apiKey}\';\r\n this.sessionId = \'${room.sessionId}\';\r\n this.token = \'${room.token}\';\r\n`);
        this.cameraPermissionStatus.sessionActive = true;
        this.openTokSessionSubject.next(this.session);
        return this.openTokSession$;
    }
    connect() {
        return new Promise((resolve, reject) => {
            this.session.connect(this.token, (err) => {
                if (err) {
                    reject(err);
                }
                else {
                    resolve(this.session);
                }
            });
        });
    }
};
OpentokService.ctorParameters = () => [
    { type: Platform },
    { type: BrowserDetectService },
    { type: ErrorHandlerService },
    { type: AndroidPermissions },
    { type: GetUserMediaSupportService }
];
OpentokService.ngInjectableDef = ɵɵdefineInjectable({ factory: function OpentokService_Factory() { return new OpentokService(ɵɵinject(Platform), ɵɵinject(BrowserDetectService), ɵɵinject(ErrorHandlerService), ɵɵinject(AndroidPermissions$1), ɵɵinject(GetUserMediaSupportService)); }, token: OpentokService, providedIn: "root" });
OpentokService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], OpentokService);

// ### Session Signaling
//
// Session signaling breaks down into four categories:
//
// - Control signals – Request the user client to change state or perform an action. Will receive an acknowledgement.
// - Queries – Requests for information from the user client. Will be responded to with an info signal.
// - Info – Info provided by the user client.
// - Acknowledgements – Either ACK or NACK, indicating the signal was received and either processed or could not be processed.
//
//   Signal parameters are JSON-encoded. All signals should be sent with an `id` field that uniquely identifies the packet. This field is implied in the descriptions below.
//
//   #### Control Signals
//
// ##### `control_play_intro`
//
// Plays the session intro (start) sound for the user.
//
//   ##### `control_play_outro`
//
// Plays the session outro (end) sound for the user.
//
var RoomSignalTypes;
(function (RoomSignalTypes) {
    RoomSignalTypes["ack"] = "ACK";
    RoomSignalTypes["nack"] = "NACK";
    /**
     * CONTROL SIGNALS
     */
    RoomSignalTypes["control_source_default"] = "control_source_default";
    RoomSignalTypes["control_source_stream"] = "control_source_stream";
    RoomSignalTypes["control_source_library"] = "control_source_library";
    RoomSignalTypes["control_fit"] = "control_fit";
    RoomSignalTypes["control_play"] = "control_play";
    RoomSignalTypes["control_pause"] = "control_pause";
    RoomSignalTypes["control_seek"] = "control_seek";
    RoomSignalTypes["control_playback_rate"] = "control_playback_rate";
    RoomSignalTypes["control_reload"] = "control_reload";
    RoomSignalTypes["control_end_session"] = "control_end_session";
    /**
     * @param data.url - Fully qualified url to the document
     * @param data.id - Id of the document
     * @param data.type - Type of document.  Currently the only supported value is PDF
     * @param data.pageNumber - 1-based page number for the document.  May be 0 or empty
     */
    RoomSignalTypes["control_show_document"] = "control_show_document";
    RoomSignalTypes["control_refresh_document"] = "control_refresh_document";
    /**
     * Signal to tell the member client to open the URL so the member can pay
     * @param data.url - Fully qualified url to the document
     * @param data.inApp - <true to open in a modal web view, false to open in system browser>
     */
    RoomSignalTypes["control_open_web"] = "control_open_web";
    /**
     * Data is an array
     * @param data.url - Fully qualified url to the document to cache
     */
    RoomSignalTypes["control_cache_documents"] = "control_cache_documents";
    /**
     * QUERY SIGNALS
     */
    //
    // Requests current device info from the user client. See [`info_device_info`](#info_device_info).
    //
    RoomSignalTypes["query_device_info"] = "query_device_info";
    //
    // Requests the current location of the user's device. See [`info_location`](#info_location).
    //
    RoomSignalTypes["query_location"] = "query_location";
    //
    // Requests the user client's current video playback state. See [`info_video_playback`](#info_video_playback).
    //
    RoomSignalTypes["query_video_playback"] = "query_video_playback";
    /**
     * INFO SIGNALS
     */
    // The current device info for the user client. This signal will be sent automatically any time the device info changes. Fields:
    //
    // {
    //   type: string = "phone" | "pad" | "desktop" | "unknown"
    //   orientation: string = "landscape" | "portrait" | "unknown"
    //   height: float
    //   width: float
    // }
    RoomSignalTypes["info_device_info"] = "info_device_info";
    // The current location of the user's device. Fields:
    //
    // {
    //   latitude: double
    //   longitude: double
    // }
    RoomSignalTypes["info_location"] = "info_location";
    //
    // The current video playback state of the user client. This signal will be sent any time the video loading or playback state changes. Fields:
    //
    // {
    //   loadingState: string = "readyToPlay" | "failed" | "unknown"
    //   playbackState: string = "waitingToPlay" | "paused" | "playing" | "unknown"
    //   time: float (seconds)
    //   rate: float
    // }
    RoomSignalTypes["info_video_playback"] = "info_video_playback";
    //
    // The current document status on the client
    //
    // {
    //   page: number,
    //   state: string = "loading" | "loaded" | "page change" | "unknown"
    //   url: string
    // }
    RoomSignalTypes["info_document_display"] = "info_document_display";
})(RoomSignalTypes || (RoomSignalTypes = {}));

var RoomSignalCategory;
(function (RoomSignalCategory) {
    RoomSignalCategory["none"] = "";
    RoomSignalCategory["control"] = "control";
    RoomSignalCategory["query"] = "query";
    RoomSignalCategory["info"] = "info";
})(RoomSignalCategory || (RoomSignalCategory = {}));

let SignalUtilityService = class SignalUtilityService {
    constructor() { }
    /**
     * Parse the signal type and return the first portion of the string which should be one of RoomSignalCatgory
     * @param roomSignalType
     */
    getSignalCategory(roomSignalType) {
        if (roomSignalType && roomSignalType.toString) {
            const roomSignalTypeString = roomSignalType.toString();
            if (roomSignalTypeString && roomSignalTypeString.length > 0) {
                const roomSignalTypeSplitString = roomSignalTypeString.split('_');
                return roomSignalTypeSplitString[0];
            }
        }
    }
    isInfoSignal(roomSignalType) {
        return this.getSignalCategory(roomSignalType) === RoomSignalCategory.control;
    }
    getQuerySignalForInfoSignal(roomSignalType) {
        if (roomSignalType === RoomSignalTypes.info_device_info) {
            return RoomSignalTypes.query_device_info;
        }
        else if (roomSignalType === RoomSignalTypes.info_location) {
            return RoomSignalTypes.query_location;
        }
        else if (roomSignalType === RoomSignalTypes.info_video_playback) {
            return RoomSignalTypes.query_video_playback;
        }
    }
    getInfoSignalForQuerySignal(roomSignalType) {
        if (roomSignalType === RoomSignalTypes.query_device_info) {
            return RoomSignalTypes.info_device_info;
        }
        else if (roomSignalType === RoomSignalTypes.query_location) {
            return RoomSignalTypes.info_location;
        }
        else if (roomSignalType === RoomSignalTypes.query_video_playback) {
            return RoomSignalTypes.info_video_playback;
        }
    }
};
SignalUtilityService.ngInjectableDef = ɵɵdefineInjectable({ factory: function SignalUtilityService_Factory() { return new SignalUtilityService(); }, token: SignalUtilityService, providedIn: "root" });
SignalUtilityService = __decorate([
    Injectable({
        providedIn: 'root'
    })
], SignalUtilityService);

let VertueHttpService = class VertueHttpService {
    constructor(errorHandlerService, authService, http, vertueServiceConfig) {
        this.errorHandlerService = errorHandlerService;
        this.authService = authService;
        this.http = http;
        this.headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.vertueServiceConfig = vertueServiceConfig;
    }
    constructUrl(path) {
        return this.vertueServiceConfig.vertueApiUrl + (path[0] === '/' ? '' : '/') + path;
    }
    /**
     * Handle errors by showing a dialog, then pass the observable back
     * @param serviceObservable
     * @param request
     * @param method
     * @param url
     */
    handleError(serviceObservable, request, method, url) {
        return serviceObservable.pipe(catchError((error, caught) => {
            this.errorHandlerService.showErrorDialog(error, undefined, method, url);
            return throwError(error);
        }));
    }
    get(url, opt) {
        // if (!opt) {
        //     opt = {};
        // }
        // if (!opt.headers) {
        //     opt.headers = new HttpHeaders();
        // }
        //
        // const headers: HttpHeaders = new HttpHeaders();
        // headers.append('Authorization', 'Bearer ' + this.authService.jstToken);
        // opt.headers = headers;
        //
        // debugger;
        return this.handleError(this.http.get(this.constructUrl(url), opt), undefined, 'get', url);
    }
    post(url, body) {
        const bodyString = JSON.stringify(body);
        return this.handleError(this.http.post(this.constructUrl(url), bodyString, { headers: this.headers }), body, 'post', url);
    }
    put(url, body) {
        return this.handleError(this.http.put(this.constructUrl(url), { headers: this.headers }), body, 'put', url);
    }
    delete(url, opt) {
        return this.handleError(this.http.delete(this.constructUrl(url), opt), undefined, 'delete', url);
    }
};
VertueHttpService.ctorParameters = () => [
    { type: ErrorHandlerService },
    { type: AuthService },
    { type: HttpClient },
    { type: VertueServiceConfig, decorators: [{ type: Optional }] }
];
VertueHttpService.ngInjectableDef = ɵɵdefineInjectable({ factory: function VertueHttpService_Factory() { return new VertueHttpService(ɵɵinject(ErrorHandlerService), ɵɵinject(AuthService), ɵɵinject(HttpClient), ɵɵinject(VertueServiceConfig, 8)); }, token: VertueHttpService, providedIn: "root" });
VertueHttpService = __decorate([
    Injectable({
        providedIn: 'root'
    }),
    __param(3, Optional())
], VertueHttpService);

var PhoneTypes;
(function (PhoneTypes) {
    PhoneTypes["phone"] = "phone";
    PhoneTypes["pad"] = "pad";
    PhoneTypes["unknown"] = "unknown";
})(PhoneTypes || (PhoneTypes = {}));

/*
 * Public API Surface of vertue-common
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AuthGuard, AuthService, BrowserDetectService, DebugService, ErrorHandlerDialogComponent, ErrorHandlerService, GetUserMediaSupportService, LoadingService, LocalStorageService, OpentokService, PhoneNumberPipe, PhoneOrientation, PhoneTypes, RoomSignalCategory, RoomSignalTypes, SignalUtilityService, StudentDocumentLoadingStatus, StudentDocumentName, StudentViewService, StudentViewType, UrlManagementService, VertueCommonModule, VertueHttpService, VertueServiceConfig, VideoLoadingState, VideoPlaybackState, StudentDocViewerComponent as ɵa };
//# sourceMappingURL=vertue-common.js.map
